import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from '@gosuite/button';
import { CheckboxModule } from '@gosuite/checkbox';
import { IconModule } from '@gosuite/icons';
import { InputModule } from '@gosuite/input';
import { PopoverModule } from '@gosuite/popover';

import { PlatTopMenuModule } from '../layout/components/platTopMenu/platTopMenu.module';
import { TranslateModule } from '../shared/i18n/translate.module';
import { WindowRef } from '../shared/services/window-ref';
import { LoginComponent } from './login.component';

@NgModule({
	declarations: [ LoginComponent ],
	exports: [ LoginComponent ],
	providers: [ WindowRef ],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		PlatTopMenuModule,
		InputModule,
		IconModule,
		TranslateModule,
		ButtonModule,
		CheckboxModule,
		PopoverModule,
		HttpClientModule,
	]
})
export class LoginModule {}



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts